import Api from './Api';
import geoJsonUtils from '../js/utils/geoJsonUtils';

const cache = new Map();

function composeSigpacReference(f) {
  if (!f) return '';
  const parts = [
    f.provincia,
    f.municipio,
    f.agregado,
    f.zona,
    f.poligono,
    f.parcela,
    f.recinto,
  ];
  if (parts.some((p) => p === null || p === undefined)) return '';
  return parts.join('-');
}

export async function fetchPlantationSigpacCodes(companyId, sectorId, isGisV2 = true) {
  if (!companyId || !sectorId) return [];
  if (cache.has(sectorId)) return cache.get(sectorId);
  try {
    const xhr = await Api.getSectorById(companyId, sectorId);
    const sector = JSON.parse(xhr.response);
    const geoFeature = sector?.geo_feature;
    if (!geoFeature?.features?.length) {
      cache.set(sectorId, []);
      return [];
    }
    const features = await geoJsonUtils.intersectSIGPACLayer(false, geoFeature, companyId, isGisV2);
    const codes = (features ?? [])
      .map(composeSigpacReference)
      .filter((c) => c.length > 0);
    const unique = [...new Set(codes)];
    cache.set(sectorId, unique);
    return unique;
  } catch (error) {
    return [];
  }
}

export function clearPlantationSigpacCache() {
  cache.clear();
}

export default { fetchPlantationSigpacCodes, clearPlantationSigpacCache };
